import { useAppSelector } from "./redux";

export const MembershipMapStyle: any = {
  free: {
    avatarBg: "96354f16.png",
    text: "Free",
    backgroundColor: "#EEF6FD",
    textColor: "#0191F8",
  },
  trial: {
    avatarBg: "96354f16.png",
    text: "Trial",
    backgroundColor: "#EEF6FD",
    textColor: "#0191F8",
  },
  basic: {
    avatarBg: "1586dc78.png",
    text: "Starter",
    backgroundColor: "#E9D7C6",
    textColor: "#3A261F",
  },
  standard: {
    avatarBg: "19552fa4.png",
    text: "Professional",
    backgroundColor: "#E1EBF4",
    textColor: "#333C53",
  },
  premium: {
    avatarBg: "cf294e5e.png",
    text: "Enterprise",
    backgroundColor: "#F9EABC",
    textColor: "#3A261F",
  },
  expired: {
    avatarBg: "0ef6d6ad.png",
    text: "Expired",
    backgroundColor: "#F5F5F5",
    textColor: "#BBB",
  },
};

export const useMembershipLevel = () => {
  const { membership } = useAppSelector((state) => state.globalReducer);
  let level = "";
  const isPremium = membership?.level?.toLocaleLowerCase() === "premium";
  let isProfessionalUp = false; // 是否是专业版及以上
  if (membership) {
    if (membership.expired) {
      level = "expired";
    } else {
      level = membership.level.toLocaleLowerCase();
      isProfessionalUp = level === "standard" || level === "premium";
    }
  }

  return { membershipLevel: level, isProfessionalUp, isBasicUp: true, isExpired: membership?.expired, isPremium };
};
